// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__3uesq","vLegacy":"SelectSecondary_vLegacy__o_iT1","error":"SelectSecondary_error__1QHVH","disabled":"SelectSecondary_disabled__kC_fu"};